<template>
  <main class="home">
    <!-- Stage -->
    <div class="stage">
      <div class="intro" :style="`background-image: url(${require(`@/assets/img/header.png`)});`">
        <h1>
          <strong>
            DANO
            <span>&reg;</span>
          </strong>
          <span>PROFILBERATER</span>
        </h1>
      </div>
    </div>

    <p class="intro-content">
      Mit dem DANO<sup>®</sup> Profilberater finden Sie mit wenigen Klicks die richtigen
      Rahmenbedingungen für Ihre Wandkonstruktionen. Egal ob Vorsatzschalen, Einfach- oder
      Doppelständerwände - alle Angaben für Konstruktionen mit Metall-Unterkonstruktion sind
      enthalten. <br /><br />
      Um eine vorgegebene Wandhöhe zu erreichen, müssen diverse Parameter für den Aufbau einer
      Trockenbauwand eingehalten werden. Welches CW-Profil muss verbaut werden? Welche Achsabstände
      sind einzuhalten und wie beplanke ich die Wand richtig?
      <br /><br />
      All das beantwortet Ihnen die DANO<sup>®</sup> Profil-App schnell und einfach. Wählen Sie
      einfach die gewünschte Wandhöhe aus. Zulässige Profilbreiten, Beplankungslagen und
      Achsabstände werden Ihnen angezeigt. <br /><br />
      Alle Konstruktionen sind wie gewohnt als offene Lösungen herzustellen. Kombinieren Sie ganz
      einfach DANO<sup>®</sup> Gipsplatten mit Komponenten anderer Hersteller. <br /><br />
      <Button variant="primary" url="/tapemeasure" text="Los geht's" class="stageButton" />
    </p>

    <h1>DANO<sup>&reg;</sup> Produktserien im Überblick</h1>

    <SliderProducts title="Profiltechnik für Wände" type="wall" />

    <SliderProducts title="Profiltechnik für Decken" type="roof" />
  </main>
</template>

<script>
import Button from '@/components/Button.vue';
import SliderProducts from '@/components/SliderProducts.vue';

export default {
  name: 'Home',
  components: {
    SliderProducts,
    Button,
  },
};
</script>

<style lang="scss" scoped>
.home {
  padding-bottom: 13px;

  .intro {
    background-position: top right;
    background-repeat: no-repeat;
    background-size: cover;
    height: 300px;
    box-sizing: border-box;
    position: relative;

    h1 {
      position: absolute;
      bottom: 50px;
      left: 20px;
      margin: 0;
      padding: 0;

      > strong {
        font-size: 36px;
        font-weight: 400;
        line-height: 1;
        color: $color-primary;
        font-family: $font-family-bold;
        height: 36px;

        span {
          font-size: 38px;
          line-height: 42px;
          font-family: $font-family-secondary;
        }
      }
      > span {
        font-size: 36px;
        height: 36px;
        line-height: 1;
        color: $color-secondary-dark;
        display: block;
      }
    }
  }

  .intro-content {
    @media screen and (min-width: 768px) {
      max-width: 60%;
    }
  }

  .stageButton {
    margin-bottom: 35px;

    @media screen and (min-width: 768px) {
      width: 260px;
    }
  }

  .stage + h2 {
    margin-bottom: 3px;
  }

  h2 + p,
  p + .unorderedlist {
    margin-bottom: 23px;
  }

  .unorderedlist + p {
    margin-bottom: 60px;
  }

  p + h1 {
    margin-bottom: 31px;
  }

  h1 + h2 {
    margin-bottom: 17px;
  }
}
</style>
